import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  SubjectTopicTestReduxSchema,
  TestInteractionSchema,
  TopicTestReduxSchema,
} from "@tsTypes/redux-schema";
import { RootState } from "../../app/store";
import {
  createMissingSubject,
  createMissingTopic,
  getBlankResource,
  isoStringToUnixDay,
} from "../../lib/redux/helpers";

const initialState: SubjectTopicTestReduxSchema = {};

export const TopicTestUserReduxMetadataSlice = createSlice({
  name: "TopicTestUserReduxMetadata",
  initialState,
  reducers: {
    setTopicTestState: (
      state,
      action: PayloadAction<
        | {
            [subjectDocumentId: string]:
              | {
                  [topicDocumentId: string]:
                    | {
                        [testDocumentId: string]: TopicTestReduxSchema;
                      }
                    | undefined;
                }
              | undefined;
          }
        | undefined
      >,
    ) => {
      return { ...action.payload };
    },
    topicTestAttempt: (state, action: PayloadAction<TestInteractionSchema>) => {
      const {
        subjectDocumentId,
        topicDocumentId,
        date,
        testDocumentId,
        testNumber,
        percentagePerformance,
        percentageFree,
      } = action.payload;

      if (!state[subjectDocumentId]) {
        state[subjectDocumentId] = createMissingSubject();
      }
      if (!state[subjectDocumentId][topicDocumentId]) {
        state[subjectDocumentId][topicDocumentId] = createMissingTopic();
      }
      if (!state[subjectDocumentId][topicDocumentId][testDocumentId]) {
        state[subjectDocumentId][topicDocumentId][testDocumentId] =
          getBlankResource("topicTests") as TopicTestReduxSchema;
      }
      // Overwrite draft meta above with correct data. Also handles case where question already existed and just needed updating
      state[subjectDocumentId][topicDocumentId][testDocumentId].num =
        testNumber;
      state[subjectDocumentId][topicDocumentId][testDocumentId].da.push(
        isoStringToUnixDay(date),
      );
      state[subjectDocumentId][topicDocumentId][testDocumentId].perf.push(
        percentagePerformance,
      );
      state[subjectDocumentId][topicDocumentId][testDocumentId].freeTimes.push(
        percentageFree,
      );
    },
  },
});

export const { topicTestAttempt, setTopicTestState } =
  TopicTestUserReduxMetadataSlice.actions;

export function selectTestById(
  state: RootState,
  subjectDocumentId: string,
  topicDocumentId: string,
  testDocumentId: string,
) {
  return state.TopicTestUserReduxMetadata?.[subjectDocumentId]?.[
    topicDocumentId
  ]?.[testDocumentId];
}

export default TopicTestUserReduxMetadataSlice.reducer;
